<template>
    <v-flex xs12>
        <about-tile v-if="canViewAboutTile" :can-view-about="canViewAbout" :can-view-chair="canViewChair" :can-view-sponsors="canViewSponsors"></about-tile>
        <group-super-admin-options v-if="isSuperAdmin && currentCommunityView === userRoles.ADMIN"></group-super-admin-options>
        <administration-option :title="Administration.GROUP_ADMINISTRATION" :isGroup="true" v-if="isVisible && showAdminPanel && currentCommunityView === userRoles.ADMIN"></administration-option>
        <filesand-media v-if="canViewFilesAndMedia"></filesand-media>
    </v-flex>
</template>

<script>
    import AboutTile from '../ChapterPage/AboutTile/AboutTile';
    import FilesandMedia from "../ChapterPage/FilesandMedia/FilesandMedia";
    import AdministrationOption from "../NetworkPage/AdministrationOption";
    import { mapGetters } from "vuex";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { userRoles } from "../appCommon.constants";
    import { Administration } from "./groupConstant";
    import GroupSuperAdminOptions from "./GroupSuperAdminOptions/GroupSuperAdminOptions.vue";
    import communityLeftSideBarMixin from "../../mixins/communityLeftSideBarMixin";

    export default {
        name: 'GroupLeftSidebar',
        mixins: [communityLeftSideBarMixin],
        data: () => {
            return {
                userRoles,
                Administration,
            };
        },
        components: {
            AboutTile,
            FilesandMedia,
            AdministrationOption,
            GroupSuperAdminOptions,
        },
        computed: {
            ...mapGetters({
                currentCommunityView: `${storeGetters.currentCommunityView}`,
                userPermissionsData: `auth/${storeGetters.permissionsData}`,
                usersCommunitiesList: `chapter/${storeGetters.usersCommunitiesList}`,
            }),
            isVisible() {
                return this.$route.params.communityId !== undefined;
            },
            isSuperAdmin() {
                return this.userPermissionsData && this.userPermissionsData.userRoles && this.userPermissionsData.userRoles.some(o => o === "Group Super Administrator");
            },
            canViewFilesAndMedia() {
                return this.communityInfo
                    && this.communityInfo.communityId === this.$route.params.communityId
                    && this.communityInfo.userAccess
                    && this.communityInfo.userAccess.canViewAllFilesAndMedia;
            },
            showAdminPanel() {
                return (this.communityInfo && this.communityInfo.communityId === this.$route.params.communityId && this.communityInfo.isAdmin && this.currentCommunityView !== userRoles.MEMBER) || (this.isSuperAdmin && this.usersCommunitiesList && !this.usersCommunitiesList.some(c =>
                    c.communityType.toLowerCase() === this.$route.name.toLowerCase()));
            },
        },
    };
</script>
